import { render, staticRenderFns } from "./formItem.vue?vue&type=template&id=6e8f6296"
import script from "./formItem.vue?vue&type=script&lang=js"
export * from "./formItem.vue?vue&type=script&lang=js"
import style0 from "./formItem.vue?vue&type=style&index=0&id=6e8f6296&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports